import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A1D37] pt-20 pb-10 border-t border-white/5">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          {/* Column 1: Brand Bio */}
          <div className="md:col-span-1">
            <div className="text-white font-black text-2xl tracking-tighter mb-6">
              EHSAN <span className="text-[#D62828]">TRADERS.</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Empowering entrepreneurs with cutting-edge digital infrastructure, from custom software to global SEO dominance.
            </p>
            <div className="flex space-x-4 text-slate-400">
              <a href="#" className="hover:text-[#D62828] transition-colors"><i className="fab fa-facebook-f"></i></a>
              <a href="#" className="hover:text-[#D62828] transition-colors"><i className="fab fa-linkedin-in"></i></a>
              <a href="#" className="hover:text-[#D62828] transition-colors"><i className="fab fa-github"></i></a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-[0.2em] text-xs mb-6">Navigation</h4>
            <ul className="space-y-4 text-slate-400 text-sm">
              <li><a href="#home" className="hover:text-white transition-colors">Home</a></li>
              <li><a href="#ceo" className="hover:text-white transition-colors">About CEO</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Services</a></li>
              <li><a href="#portfolio" className="hover:text-white transition-colors">Portfolio</a></li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-[0.2em] text-xs mb-6">Services</h4>
            <ul className="space-y-4 text-slate-400 text-sm">
              <li><a href="#services" className="hover:text-white transition-colors">Web Development</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Desktop Apps</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">SEO Optimization</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Business Support</a></li>
            </ul>
          </div>

          {/* Column 4: Newsletter/CTA */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-[0.2em] text-xs mb-6">Newsletter</h4>
            <div className="relative">
              <input 
                type="email" 
                placeholder="Your email" 
                className="w-full bg-white/5 border border-white/10 py-3 px-4 text-white text-sm outline-none focus:border-[#D62828] transition-all"
              />
              <button className="absolute right-2 top-1/2 -translate-y-1/2 text-[#D62828] hover:text-white transition-colors">
                <i className="fas fa-paper-plane"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-[10px] uppercase tracking-widest">
            © {currentYear} Ehsan Traders. All Rights Reserved.
          </p>
          
          <div className="text-slate-500 text-[10px] uppercase tracking-widest flex items-center">
            Built with <span className="text-[#D62828] mx-2 text-xs">♥</span> by Ehsan Traders Team
          </div>
        </div>
      </div>

      {/* Finishing Touch: Signature Gradient Line */}
      <div className="mt-10 h-1 w-full bg-gradient-to-r from-transparent via-[#D62828]/30 to-transparent"></div>
    </footer>
  );
};

export default Footer;